import * as angular from "angular";
import "./newsletter-data-table.component.css";

const newsletterDataTableConfig = {
    template: `
        <mw-table class="mw-outputs-data-table">
            <header class="mw-table__header" ng-class="[{'mw-table__header--selected-items': $ctrl.selectedItems.length}]">
                <!-- default toolbar -->
                <mw-collection-header
                    ng-if="$ctrl.showHeader()"
                    is-search-active="$ctrl.NewslettersStateService.isSearchVisible"
                    is-header-title-visible="$ctrl.isHeaderTitleVisible()"
                    on-search="$ctrl.search($event)"
                    search-input-placeholder="{{$ctrl.$translate.instant('mw-newsletter-data-table__search-placeholder')}}"
                    on-search-toggle="$ctrl.onSearchToggle($event)" collection-type="table">

                    <mw-collection-header-title>
                        <span class="mw-collection-header__title" ng-if="$ctrl.isHeaderTitleVisible()">
                            {{$ctrl.$translate.instant('mw-newsletter-data-table__table-header')}}
                        </span>
                    </mw-collection-header-title>
                    <mw-collection-header-actions>
                        <md-menu class="mw-menu" md-position-mode="target-right target"  md-offset="0 50">
                            <mw-menu-trigger-icon-button
                                icon='content:ic_sort_24px'
                                tooltip="{{'mw-newsletter-data-table__sort-tooltip' | translate}}"
                                on-click='$mdOpenMenu($event)'></mw-menu-trigger-icon-button>
                            <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="orderBy in $ctrl.NewslettersStateService.orderByOptions"
                                    is-selected="orderBy == $ctrl.NewslettersStateService.orderBy"
                                    on-click="$ctrl.setOrderBy(orderBy)">

                                    {{$ctrl.$translate.instant('mw-newsletter-data-table__order-by-' + orderBy)}}
                                </mw-menu-item>
                                <md-divider class="mw-menu-divider"></md-divider>
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="sortOrder in $ctrl.NewslettersStateService.sortOrderOptions"
                                    is-selected="$ctrl.convertSortOrder(sortOrder) === $ctrl.NewslettersStateService.sortOrder"
                                    on-click="$ctrl.setSortOrder(sortOrder)">

                                    {{$ctrl.$translate.instant('mw-newsletter-data-table__sort-' + sortOrder)}}
                                </mw-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </mw-collection-header-actions>
                </mw-collection-header>
                <!-- selected items toolbar -->
                <mw-collection-bulk-action
                    ng-if="$ctrl.selectedItems.length"
                    selected-items="$ctrl.selectedItems"
                    on-reset-selected-items="$ctrl.resetSelectedItems($event)">

                    <md-button
                        ng-click="::$ctrl.onPause()"
                        ng-disabled="$ctrl.playPauseDisabled"
                        class="md-icon-button"
                        aria-label="{{::'newsletter__automation-pause-tooltip' | translate}"
                        ng-if="$ctrl.selectedItems.length == 1 && $ctrl.isRecurringNewsletter($ctrl.selectedItems[0])">

                        <div ng-if="$ctrl.selectedItems[0].settings.paused">
                            <md-tooltip md-delay="500">
                                <span translate>newsletter__automation-play-tooltip</span>
                            </md-tooltip>
                            <md-icon md-svg-icon="av:ic_play_arrow_24px"></md-icon>
                        </div>
                        <div ng-if="!$ctrl.selectedItems[0].settings.paused">
                            <md-tooltip md-delay="500">
                                <span translate>newsletter__automation-pause-tooltip</span>
                            </md-tooltip>
                            <md-icon md-svg-icon="av:ic_pause_24px"></md-icon>
                        </div>

                    </md-button>
                    <md-button
                        ng-click="::$ctrl.createDistribution()"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-data-table__action-create-distribution' | translate}"
                        ng-if="$ctrl.selectedItems.length == 1 && !$ctrl.isRecurringNewsletter($ctrl.selectedItems[0]) && !$ctrl.selectedItems[0].settings.oneOff">

                        <md-tooltip md-delay="500">
                            <span translate>mw-newsletter-data-table__action-create-distribution</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="av:ic_playlist_add_24px"></md-icon>
                    </md-button>
                    <md-button
                        ng-click="::$ctrl.editNewsletter()"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-data-table__action-edit' | translate}"
                        ng-if="$ctrl.selectedItems.length == 1 && $ctrl.newsletterPermissions && (!$ctrl.selectedItems[0].settings.oneOff || ($ctrl.selectedItems[0].settings.oneOff  && $ctrl.NewslettersStateService.oneOffNLEnabled))">

                        <md-tooltip md-delay="500"><span translate>Edit</span></md-tooltip>
                        <md-icon md-svg-icon="meltwater:edit">edit</md-icon>
                    </md-button>
                    <md-button
                        ng-click="::$ctrl.deleteNewsletters($ctrl.selectedItems[0],$event)"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-data-table__action-delete' | translate}}"
                        ng-if="$ctrl.selectedItems.length == 1">

                        <md-tooltip md-delay="500">
                            <span translate>Delete</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="action:ic_delete_24px">delete</md-icon>
                    </md-button>
                </mw-collection-bulk-action>
            </header>
            <md-card ng-if="$ctrl.NewslettersStateService.searchText && $ctrl.NewslettersStateService.filteredItems.length === 0">
                <md-card-content class="mw-empty-state-container">
                    <mw-empty-state text="{{$ctrl.translatedEmptySearchResultsText}}"></mw-empty-state>
                </md-card-content>
            </md-card>
            <md-card ng-if="!($ctrl.NewslettersStateService.filteredItems.length === 0)">
                <md-table-container>
                    <table
                        class="mw-table--actions-visible"
                        md-table
                        md-progress="$ctrl.NewslettersStateService.loadPagePromise"
                        md-row-select="true"
                        multiple="false"
                        ng-model="$ctrl.selectedItems">

                        <thead md-head md-order="$ctrl.orderBy" md-on-reorder="$ctrl.onReorder">
                            <tr md-row>
                                <th class="mw-table__text-column mw-table__greedy-column" md-column md-order-by="name">
                                    <span translate>mw-newsletter-data-table__column-header-name</span>
                                </th>
                                <th class="mw-table__text-column" md-column md-order-by="type" hide-xs>
                                    <span translate>mw-newsletter-data-table__column-header-type</span>
                                </th>
                                <th class="mw-table__text-column" md-column md-order-by="distributionCount" hide-sm hide-xs>
                                    <span translate>mw-newsletter-data-table__column-header-distributions</span>
                                </th>
                                <th class="mw-table__text-column" md-column md-order-by="recipientListName" hide-sm hide-xs>
                                    <span translate>mw-newsletter-data-table__column-header-list</span>
                                </th>
                                <th class="mw-table__text-column" md-column md-order-by="createdByName" hide-md hide-sm hide-xs>
                                    <span translate>mw-newsletter-data-table__column-header-created-by</span>
                                </th>
                                <th class="mw-table__actions-column" md-column></th>
                            </tr>
                        </thead>
                        <tbody md-body>
                            <tr md-row
                                ng-repeat="item in $ctrl.NewslettersStateService.filteredItems | orderBy: $ctrl.NewslettersStateService.orderBy: $ctrl.NewslettersStateService.sortOrder === 'DESC' | limitTo: $ctrl.NewslettersStateService.paging.itemsPerPage: ($ctrl.NewslettersStateService.paging.selectedPage - 1) * $ctrl.NewslettersStateService.paging.itemsPerPage track by item._id"
                                md-select="item"
                                md-select-id="_id"
                                md-auto-select="false"
                                ng-click="::$ctrl.onRowClick(item, $event)"  id="{{item._id}}">

                                <td class="mw-table__text-column mw-table__greedy-column" md-cell><span>{{item.name}}</span></td>
                                <td class="mw-table__text-column" md-cell hide-xs>{{item.type}}</td>
                                <td class="mw-table__text-column" md-cell hide-sm hide-xs>{{item.distributionCount}}</td>
                                <td class="mw-table__text-column" md-cell style="max-width: 150px;" hide-sm hide-xs>{{::item.recipientListName}}</td>
                                <td class="mw-table__text-column" md-cell style="max-width: 150px;" hide-md hide-sm hide-xs>{{::item.createdByName}}</td>
                                <td class="mw-table__actions-column" md-cell>
                                    <md-menu class="mw-menu" md-position-mode="target-right target" md-offset="0 50" ng-style="{'visibility': $ctrl.selectedItems.length === 0 ? 'visible' : 'hidden'}">
                                        <mw-menu-trigger-icon-button icon="navigation:ic_more_vert_24px" tooltip="{{::'mw-collection__tooltip-menu-trigger' | translate}}" on-click="$mdOpenMenu($event)"></mw-menu-trigger-icon-button>
                                        <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                            <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                            <mw-menu-item icon="av:ic_playlist_add_24px" aria-label="{{::'mw-newsletter-data-table__action-create-distribution' | translate}}" ng-click="::$ctrl.createDistribution(item)" ng-if="!$ctrl.isRecurringNewsletter(item) && !item.settings.oneOff">{{$ctrl.$translate.instant('mw-newsletter-data-table__action-create-distribution')}}</mw-menu-item>
                                            <div ng-if="::$ctrl.isRecurringNewsletter(item)">
                                                <mw-menu-item ng-if="!item.settings.paused" icon="av:ic_pause_24px" aria-label="{{::'newsletter__automation-pause-tooltip' | translate}}" ng-click="::$ctrl.onPause(item)" >{{$ctrl.$translate.instant('newsletter__automation-pause-tooltip')}}</mw-menu-item>
                                                <mw-menu-item ng-if="item.settings.paused" icon="av:ic_play_arrow_24px" aria-label="{{::'newsletter__automation-play-tooltip' | translate}}" ng-click="::$ctrl.onPause(item)" >{{$ctrl.$translate.instant('newsletter__automation-play-tooltip')}}</mw-menu-item>
                                            </div>
                                            <div ng-if="!item.settings.oneOff || (item.settings.oneOff && $ctrl.NewslettersStateService.oneOffNLEnabled)">
                                                <mw-menu-item icon="meltwater:edit" aria-label="{{::'mw-newsletter-data-table__action--edit' | translate}}" ng-click="$ctrl.editNewsletter(item)">{{$ctrl.$translate.instant('Edit')}}</mw-menu-item>
                                            </div>
                                            <mw-menu-item icon="action:ic_delete_24px" aria-label="{{::'mw-newsletter-data-table__action--delete' | translate}}" ng-click="$ctrl.deleteNewsletters(item, $event)">{{$ctrl.$translate.instant('Delete')}}</mw-menu-item>
                                    </md-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </md-table-container>
                <md-table-pagination
                    md-limit="$ctrl.NewslettersStateService.paging.itemsPerPage"
                    md-page="$ctrl.NewslettersStateService.paging.selectedPage"
                    md-total="{{$ctrl.NewslettersStateService.paging.totalItems}}"
                    md-on-paginate="$ctrl.onPage" md-label="{of: 'of'}"></md-table-pagination>
            </md-card>
            <md-card class="mw-empty-state__wrapper" ng-if="$ctrl.NewslettersStateService.filteredItems.length === 0 && !$ctrl.isLoading && !$ctrl.NewslettersStateService.searchText">
                <md-card-content class="mw-empty-state-container">
                    <mw-empty-state text={{$ctrl.$translate.instant('newsletters__no-results-label')}} sub-text={{$ctrl.$translate.instant('mw-collection__empty-state-subtext--create-new')}}></mw-empty-state>
                </md-card-content>
            </md-card>
        </mw-table>

    `,
    selector: 'mwNewsletterDataTable',
    controller: null
};

class NewsletterDataTableComponent {
    selectedItems: Array<string>;
    newsletterPermissions: boolean;
    translatedEmptySearchResultsText: string;
    orderBy: any;
    isLoading: boolean;
    isRecurringNewsletter: any;
    playPauseDisabled: boolean;

    // onPage: any;
    // onReorder: any;

    constructor(
        private $window,
        private $mdToast,
        private $mdMedia,
        private $mdDialog,
        private $filter,
        private NewslettersStateService,
        private $location,
        private $translate,
        private OutputConfig,
        private AnalyticsService
    ) {
        'ngInject';
        this.selectedItems = [];
        this.isLoading = true;
        this.isRecurringNewsletter = this.NewslettersStateService.isRecurringNewsletter;

        // Unfortunately, the md-data-table component does not execute these event handlers with the controller being the
        // context, we need to force it as the context by using angular.bind.
        this.onPage = angular.bind(this, this.onPage);
        this.onReorder = angular.bind(this, this.onReorder);
        this.newsletterPermissions = false;
        this.playPauseDisabled = false;

    }

    $onInit() {
        this.NewslettersStateService.getNewsletterPermissions().then((permissions) => {
            this.syncOrderBy();
            this.newsletterPermissions = permissions;

            this.isLoading = true;
            this.NewslettersStateService.load()
                .finally(() => this.isLoading = false);
        });
    }

    isHeaderTitleVisible() {
        return !(this.$mdMedia('xs') && this.NewslettersStateService.isSearchVisible);
    }

    onRowClick(item, event) {
        this.$location.url('/outputs/newsletter/' + item._id + '/distributions');
    }

    editNewsletter(item, event) {
        if(!item) {
            item = this.selectedItems[0];
        }
        this.$location.url('/newsletter/edit/' + item._id + '?stepNum=0');
        this.AnalyticsService.editOutputMgr(item);

    }

    onPause(item){
        if(!item){
            item = this.selectedItems[0];
        }

        var errorToast = this.$mdToast
                .simple()
                .textContent(this.$translate.instant('Something has gone wrong behind the scenes. Please try again later.'))
                .highlightClass('md-warn'),
            pauseToast = this.$mdToast
                .simple()
                .textContent(this.$translate.instant('newsletter__automation-paused-notification')),
            resumeToast = this.$mdToast
                .simple()
                .textContent(this.$translate.instant('newsletter__automation-resume-notification'));
        this.playPauseDisabled = true;
        this.NewslettersStateService.togglePauseAutomatedNewsletter(item)
            .then(() => {
                this.playPauseDisabled = false;
                item.settings.paused = !item.settings.paused;
                this.NewslettersStateService.updateFilteredItemsType();
                if(item.settings.paused){
                    this.$mdToast.show(pauseToast);
                }else{
                    this.$mdToast.show(resumeToast);
                }
            })
            .catch((error) => {
                this.$mdToast.show(errorToast);
                this.playPauseDisabled = false;
            }
        )

    }

    showHeader(){
        if(this.selectedItems.length){
            return false
        } else if(this.NewslettersStateService.filteredItems.length > 0 || this.NewslettersStateService.searchText){
            return true;
        } else if (this.NewslettersStateService.filteredItems.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    createDistribution(item){
        if(!item) {
            item = this.selectedItems[0];
        }
        this.$location.url('/newsletter/' + item._id + '/distribution/create?stepNum=0');
    }

    deleteNewsletters(item, event){
        var message = this.$translate.instant('output-mgr-list-controller__delete-newsletter--message'),
            title = this.$translate.instant('output-mgr-list-controller__delete-newsletter--title'),
            okText = this.$translate.instant('action-label__delete'),
            cancelText = this.$translate.instant('Cancel'),
            newsletterId = item._id;

        var deleteDialog = this.$mdDialog.confirm()
                .title(title)
                .textContent(message)
                .ok(okText)
                .cancel(cancelText)
                .targetEvent(event),
            butteredToast = this.$mdToast.simple().textContent(this.$translate.instant('Output was deleted')),
            burntToast = this.$mdToast.simple().textContent(this.$translate.instant('Something has gone wrong behind the scenes. Please try again later.')).highlightClass('md-warn'),
            illegalToast = this.$mdToast.simple().textContent(this.$translate.instant('delete-newsletter__description--failure-scheduled-distribution'));

        this.$mdDialog.show(deleteDialog).then(() => {
            this.NewslettersStateService.deleteNewsletter(newsletterId).then(() => {
                this.$mdToast.show(butteredToast);
                this.AnalyticsService.deleteOutputMgr(this.selectedItems[0]);
                this.selectedItems = [];

            }, (error) => {
                if(error.statusCode == 403){
                    this.$mdToast.show(illegalToast);
                }else {
                    this.$mdToast.show(burntToast);
                }
            });
        }, () => {
            //User Cancelled
        });
    }

    search(searchText) {
        this.NewslettersStateService.searchText = searchText;
        this.NewslettersStateService.filterNewsletters(searchText);
        this.translatedEmptySearchResultsText = this.$translate.instant(
            'mw-newsletters--search-empty-state__text' ,
            {searchText: '"' + this.NewslettersStateService.searchText + '"'}
        );
    }

    onSearchToggle(isSearchActive) {
        this.NewslettersStateService.searchText = '';
        this.NewslettersStateService.isSearchVisible = isSearchActive;
    };

    resetSelectedItems(event) {
        this.selectedItems = [];
    };

    onPage(page, limit) {
        this.resetTableScroll();
    }

    resetTableScroll() {
        var element = this.$window.document.getElementById('mw-newsletter-table__content');
        if (element) {
            element.scrollTop = 0;
        }
    }

    openSortMenu($mdOpenMenu, event) {
        $mdOpenMenu(event);
    }

    onReorder(order) {
        var sortOrder = 'ASC';

        if (order.substr(0, 1) === '-') {
            sortOrder = 'DESC';
            order = order.substring(1);
        }

        this.NewslettersStateService.orderBy = order;
        this.NewslettersStateService.sortOrder = sortOrder;
        this.NewslettersStateService.paging.selectedPage = 1;
    }


    setOrderBy(orderBy) {
        if (this.NewslettersStateService.orderBy !== orderBy) {
            this.NewslettersStateService.orderBy = orderBy;
            this.syncOrderBy();
        }
    }

    convertSortOrder(sortOrder) {
        return sortOrder.trim().toLowerCase() === 'ascending' ? 'ASC' : 'DESC';
    }

    setSortOrder(sortOrder) {
        var _sortOrder = this.convertSortOrder(sortOrder);
        if (this.NewslettersStateService.sortOrder !== _sortOrder) {
            this.NewslettersStateService.sortOrder = _sortOrder;
            this.syncOrderBy();

            this.isLoading = true;
            this.NewslettersStateService.load()
                .finally(() => this.isLoading = false);
        }
    }

    syncOrderBy() {
        var orderBy = this.NewslettersStateService.orderBy;
        if (this.NewslettersStateService.sortOrder === 'DESC') {
            orderBy = '-' + orderBy;
        }

        this.orderBy = orderBy;
    }

    showToast(message) {
        this.$mdToast.show(
            this.$mdToast.mwSimpleTimed()
                .textContent(message)
        );
    }

    formatDate(date) {
        return this.$filter('mwConvertDateToUserTimezone')(date, this.OutputConfig.OUTPUT_DATE_FORMAT);
    }
}

newsletterDataTableConfig.controller = NewsletterDataTableComponent;

export {
    newsletterDataTableConfig,
    NewsletterDataTableComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletters/newsletter-data-table/newsletter-data-table.component.ts
 **/